import { ClaimControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  claimId: string;
  status: string;
  xTENANTID?: string;
}

export const useUpdateClaimStatus = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimControllerApi(getConfigObject()).updateClaimStatus(
      params.claimId,
      params.status,
      params.xTENANTID
    )
  );
